import request from '../utils/request';

/**
 * 任务统计数据API服务
 */
const taskStatisticsApi = {
  /**
   * 获取任务概览统计数据
   * @returns {Promise} - 返回请求Promise
   */
  getTaskOverview: () => {
    return request({
      url: '/task-statistics/overview',
      method: 'get'
    });
  },
  
  /**
   * 获取任务概览统计数据（按时间范围）
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @returns {Promise} - 返回请求Promise
   */
  getTaskOverviewByRange: (params = {}) => {
    return request({
      url: '/task-statistics/overview/range',
      method: 'get',
      params
    });
  },
  
  /**
   * 获取任务趋势统计数据
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @returns {Promise} - 返回请求Promise
   */
  getTaskTrend: (params = {}) => {
    return request({
      url: '/task-statistics/trend',
      method: 'get',
      params
    });
  },
  
  /**
   * 获取任务分布统计数据
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @returns {Promise} - 返回请求Promise
   */
  getTaskDistribution: (params = {}) => {
    return request({
      url: '/task-statistics/distribution',
      method: 'get',
      params
    });
  }
};

export default taskStatisticsApi; 